import styled from "styled-components";
import { AppTheme } from "../../theme";

declare module "styled-components" {
  export interface DefaultTheme extends AppTheme {}
}
interface HomePageContainerProps {
  // any CSS background value, see config/wallpapers
  $background: string;
}

export const HomePageContainer = styled.div<HomePageContainerProps>`
  width: 100%;
  position: relative;
  height: 100vh;
  background: ${(props) => props.$background};
  transition: background 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

interface HomePageWindowContainerProps {
  show: boolean;
}
export const HomePageWindowContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "show",
})<HomePageWindowContainerProps>`
  position: absolute;
  z-index: 1;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: 0.3s;
  transform: ${(props) =>
    props.show ? "translate(0,0) scale(1)" : "translate(0,100%) scale(0)"};
`;

/* Very subtle scanlines + vignette over the whole desktop. Toggle from the Start menu. */
export const CRTOverlay = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 99500;
  background: repeating-linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0px,
    rgba(0, 0, 0, 0) 2px,
    rgba(0, 0, 0, 0.06) 3px
  );
  box-shadow: inset 0 0 180px rgba(0, 0, 0, 0.35);
`;
